import { Route, Switch, Redirect } from "react-router-dom";
import Coach from "components/Coach";
import FullResult from "components/Therapist/fullResult";
import CoreReport from "components/User/Evaluation/Core/CoreReport";
import CoreProReport from "components/User/Evaluation/CorePro/CoreProReport";
import NavMenu from "components/general/NavMenu";
import Profile from "components/User/ProfileRoute";
import Account from "components/auth/Account";
import PublicRoute from "./PublicRoute";

const CoachRoute = () => {
  return (
    <>
      <NavMenu />
      <Switch>
        <Route path="/profile" component={Profile} />
        <Route path="/account-setting" component={Account} />
        <Route path="/full-result/:resultId" component={FullResult} />
        <Route path="/core-report/:transactionId" component={CoreReport} />
        <Route path="/core-pro-report/:resultId" component={CoreProReport} />
        <Route exact path="/coach" component={Coach} />
        <PublicRoute />
      </Switch>
    </>
  );
};

export default CoachRoute;
